import { c as _c } from "react/compiler-runtime";
import { Dialog, Form } from '@onefootprint/ui';
import noop from 'lodash/noop';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type ConfirmMissingBoDialogProps = {
  minimumBoStake: number;
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (note: string) => void;
};
export const ConfirmMissingBoDialog = t0 => {
  const $ = _c(52);
  const {
    minimumBoStake,
    isLoading,
    isOpen,
    onClose,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectBusinessData.beneficialOwners.form"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      defaultValues: {
        note: ""
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const methods = useForm(t2);
  const {
    handleSubmit,
    reset
  } = methods;
  let t3;
  if ($[2] !== onSubmit) {
    t3 = t4 => {
      const {
        note
      } = t4;
      onSubmit(note);
    };
    $[2] = onSubmit;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onSubmitFormData = t3;
  let t4;
  if ($[4] !== isLoading || $[5] !== onClose || $[6] !== reset) {
    t4 = () => {
      if (isLoading) {
        return;
      }
      reset();
      onClose();
    };
    $[4] = isLoading;
    $[5] = onClose;
    $[6] = reset;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleOnClose = t4;
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = isLoading ? noop : handleOnClose;
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp2);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleOnClose || $[13] !== isLoading || $[14] !== t7) {
    t8 = {
      label: t7,
      disabled: isLoading,
      onClick: handleOnClose
    };
    $[12] = handleOnClose;
    $[13] = isLoading;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t(_temp3);
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isLoading || $[19] !== t9) {
    t10 = {
      type: "submit",
      form: "no-other-bos-form",
      label: t9,
      loading: isLoading
    };
    $[18] = isLoading;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== handleSubmit || $[22] !== onSubmitFormData) {
    t11 = handleSubmit(onSubmitFormData);
    $[21] = handleSubmit;
    $[22] = onSubmitFormData;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== minimumBoStake || $[25] !== t) {
    t12 = t(_temp4, {
      minimumBoStake
    });
    $[24] = minimumBoStake;
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12) {
    t13 = <p className="text-body-2 text-primary text-center fp-text">{t12}</p>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t(_temp5);
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t(_temp6);
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = <Form.Textarea name="note" label={t14} placeholder={t15} />;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t13 || $[37] !== t16) {
    t17 = <div className="flex flex-col gap-6">{t13}{t16}</div>;
    $[36] = t13;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t11 || $[40] !== t17) {
    t18 = <form id="no-other-bos-form" onSubmit={t11}>{t17}</form>;
    $[39] = t11;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== methods || $[43] !== t18) {
    t19 = <FormProvider {...methods}>{t18}</FormProvider>;
    $[42] = methods;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== isOpen || $[46] !== t10 || $[47] !== t19 || $[48] !== t5 || $[49] !== t6 || $[50] !== t8) {
    t20 = <Dialog isConfirmation={true} title={t5} open={isOpen} size="compact" onClose={t6} secondaryButton={t8} primaryButton={t10}>{t19}</Dialog>;
    $[45] = isOpen;
    $[46] = t10;
    $[47] = t19;
    $[48] = t5;
    $[49] = t6;
    $[50] = t8;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  return t20;
};
function _temp($) {
  return $["missing-bos-confirmation"].title;
}
function _temp2($_0) {
  return $_0["missing-bos-confirmation"]["secondary-cta"];
}
function _temp3($_1) {
  return $_1["missing-bos-confirmation"]["primary-cta"];
}
function _temp4($_2) {
  return $_2["missing-bos-confirmation"].description;
}
function _temp5($_3) {
  return $_3["missing-bos-confirmation"]["input-label"];
}
function _temp6($_4) {
  return $_4["missing-bos-confirmation"]["input-placeholder"];
}